import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import { FieldError } from "react-hook-form";

type RadioProps = {
  label?: string;
  description?: string;
  error?: FieldError;
  htmlFor?: string;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "type"
>;

// MIGRATE: WOMBAT UI
const Radio = React.forwardRef<HTMLInputElement, RadioProps>(
  ({ label, description, error = {}, htmlFor, ...props }, ref) => {
    if (label)
      return (
        <div className="relative flex items-start">
          <div className="flex items-center h-5">
            <input
              {...props}
              ref={ref}
              type="radio"
              className="w-4 h-4 transition duration-150 ease-in-out text-primary-600 form-radio"
            />
          </div>
          <div className="ml-3 text-sm leading-5">
            <label htmlFor={htmlFor} className="font-medium text-gray-700">
              {label}
            </label>
            {description && <p className="text-gray-500">{description}</p>}
            {error?.message && <p className="text-red-600">{error.message}</p>}
          </div>
        </div>
      );

    return (
      <input
        {...props}
        ref={ref}
        type="checkbox"
        className="w-4 h-4 transition duration-150 ease-in-out text-primary-600 form-checkbox"
      />
    );
  }
);

export default React.memo(Radio);
